export enum MaskEnum {
    CPF = "cpf",
    CNPJ = "cnpj",
    CEP = "cep",
    PHONE = "phone",
    MONEY = "money",
    DATE = "date",
    TIME = "time",
    PERCENTAGE = "percentage",
    NONE = "none",
  }